module.exports = __webpack_public_path__ + "img/edit_dark.ac66ef83.svg";